/* src/app/module/service-advisors/add-service-advisor/add-service-advisor-details/add-service-advisor-details.component.scss */
.form-container {
  margin: 0 auto;
  background: #ffffff;
  border-radius: 10px;
}
.heading {
  margin-bottom: 43px;
}
h2 {
  margin-bottom: 20px;
  font-size: 24px;
}
h3 {
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
}
::ng-deep .p-col-12 {
  margin-bottom: 20px;
}
::ng-deep .p-col-12.p-md-6,
.p-col-12.p-md-4 {
  padding-left: 0.5em;
  padding-right: 0.5em;
}
.custom-upload-button {
  border: none;
  padding: 10px 16px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease, transform 0.3s ease;
}
.custom-upload-button:disabled {
  background-color: #FFD9AA;
  border: 1px solid #FFD9AA;
  cursor: not-allowed;
}
.custom-upload-button .arrow {
  margin-left: 8px;
  font-size: 16px;
  transition: margin-left 0.3s ease;
}
.custom-upload-button:hover:not(:disabled) .arrow {
  margin-left: 12px;
}
::ng-deep ::placeholder {
  color: #667085 !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}
::ng-deep .p-dropdown .p-dropdown-label.p-placeholder {
  color: var(--Gray-900, #101828);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
}
::ng-deep .p-highlight {
  color: #D47500;
  background: #FFF1E0;
}
::ng-deep .ng-invalid.ng-touched {
  border-color: darkred !important;
  box-shadow: none !important;
}
::ng-deep .p-inputtext.ng-invalid.ng-touched,
::ng-deep .p-dropdown.ng-invalid.ng-touched .p-dropdown-label,
::ng-deep .p-dropdown.ng-invalid.ng-touched .p-dropdown-trigger {
  border-color: darkred !important;
  background-color: #ffe6e6 !important;
}
::ng-deep .field-wrapper.ng-invalid.ng-touched .p-inputtext,
::ng-deep .field-wrapper.ng-invalid.ng-touched .p-dropdown {
  border-color: darkred !important;
  background-color: #ffe6e6 !important;
}
::ng-deep label {
  color: var(--Gray-700, #344054);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
}
::ng-deep .p-dropdown {
  margin-top: 8px;
}
::ng-deep input {
  margin-top: 8px;
  margin-bottom: 4px;
}
::ng-deep textarea {
  margin-top: 8px;
  margin-bottom: 4px;
}
::ng-deep .formly-validation-message {
  margin-top: 4px;
  color: #e24c4c;
  font-weight: bold;
}
form {
  width: 800px;
}
:host ::ng-deep .p-datepicker {
  transform-origin: top center !important;
  top: unset !important;
  bottom: auto !important;
  margin-top: 60px !important;
}
@media screen and (max-width: 1200px) {
  :host ::ng-deep .p-datepicker {
    transform-origin: top center !important;
    top: unset !important;
    bottom: auto !important;
    margin-top: 60px !important;
  }
}
/*# sourceMappingURL=add-service-advisor-details.component-B3DSPAJ3.css.map */
